import FileSaver from 'file-saver';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { userService } from '@saucelabs/sl-util-axios';

import { generateReportName } from './../activity/utils';

export const getUsers = ({ limit = PAGINATION_LIMIT, offset = 0, ...rest } = {}) => (
  userService.get('/v1/users/', {
    params: {
      limit,
      offset,
      ...rest,
    },
  })
);

export const patchUser = ({ userId, ...params }) => (
  userService.patch(`/v1/users/${userId}/`, params)
);

export const grantOrgAdmin = (userId) => (
  userService.post(`/v1/users/${userId}/set-admin/`)
);

export const grantTeamAdmin = (userId) => (
  userService.post(`/v1/users/${userId}/set-team-admin/`)
);

export const demoteToMember = (userId) => (
  userService.post(`/v1/users/${userId}/set-member/`)
);

export const deactivateUser = (userId) => (
  userService.post(`/v1/users/${userId}/deactivate/`)
);

export const reactivateUser = (userId) => (
  userService.post(`/v1/users/${userId}/activate/`)
);

export const postMembership = ({ userId, teamId }) => {
  const data = {
    user: userId,
    team: teamId,
  };
  return userService.post('/v1/membership/', data);
};

export const postResetAccessKey = (userId) => (
  userService.post(`/v1/users/${userId}/reset-access-key/`)
);

export const removeMembership = (data) => (
  userService.post('/v1/membership/delete/', data).then(() => data)
);

export const patchOrganization = ({ id, ...data }) => (
  userService.patch(`/v1/organizations/${id}/`, data)
);

export const getOrganizationUsersUsageCSV = ({ id, name }) => (
  userService.get(`/v1/organizations/${id}/members-activity/`, {
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  }).then(({ data }) => {
    FileSaver.saveAs(data, generateReportName({
      rootSection: name,
      reportType: 'all',
    }));
  })
);
